import { Image, Text, View } from '@react-pdf/renderer';
import { S3_URL } from 'constants';
import parse from 'html-react-parser';
import { convertToPng } from 'utils';

const About = ({
	styles,
	data: { profilePicture = '', shortBio = '', firstName = '', lastName = '', designation = '' },
}: any) => {
	return (
		<View style={styles.aboutbox}>
			{profilePicture && (
				<View style={styles.profileImgBox}>
					<Image
						style={styles.profileImg}
						src={convertToPng(S3_URL + profilePicture)}
						loading="lazy"
					/>
				</View>
			)}
			<View style={styles.aboutDetail}>
				{(firstName || lastName) && (
					<Text style={styles.userName}>
						{firstName} {lastName}
					</Text>
				)}
				{designation && <Text style={styles.designation}>{designation}</Text>}
				{shortBio && <Text style={styles.detailSubText}>{parse(shortBio)} </Text>}
			</View>
		</View>
	);
};

export default About;
